import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { planHasLapsed } from '@/pages/PlanRequired';

/**
 * Signed-in only. When a paid plan has lapsed (payment failed past the grace
 * period, or a cancelled plan reached its end), every page except billing and
 * profile shows Plan required instead — `allowLapsed` marks those pages.
 */
export default function ProtectedRoute({ children, allowLapsed = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="h-3 w-3 animate-pulse rounded-full bg-primary" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (!allowLapsed && planHasLapsed(user)) return <Navigate to="/plan-required" replace />;

  return children;
}
